// ----------------------------------------------------------------------------
// Удаление чего-то в ЛК (вспомогательные функции)
// ----------------------------------------------------------------------------



import {hideElement, showElement} from "../visibility/showHide.js";
import {removeElements} from "../auth-common/auth-misc-functions.js";
import ttLKScrollToMessage from "./tt-LK-scroll-to-message.js";
import {createSimpleModal, closeModalWindow} from "../modal/modal-window-manager.js";
import createElement from "../create/createElement.js";
import {accountElements, authElements} from "../auth-common/auth-account-elements.js";


// ----------------------------------------------------------------------------
// При удалении аватара

export function deleteAvatarHelp(e) {
    e?.preventDefault();
    const content = 'Вы действительно хотите удалить фото профиля?';
    const confirmButton = createElement('button', {class: ['button', 'button--s', 'button--black']}, 'Удалить');
    const cancelButton = createElement('button', {type: 'button', class: ['button', 'button--s', 'button--black']}, 'Отменить');

    const modalFooter = createElement('div', {class: 'modal-window__2btns'});
    modalFooter.append(confirmButton);
    modalFooter.append(cancelButton);

    createSimpleModal(content, undefined, modalFooter);
    confirmButton.addEventListener('click', () => deleteInAccountSmth());
    cancelButton.addEventListener('click', (event) => {
        closeModalWindow(event);
        removeElements('.g-message');
    });

    window.actionType = 'avatar-del';
}



// ----------------------------------------------------------------------------
// При удалении соцсети

export function deleteSocialNetworkHelp(e) {
    if (!e || !e.currentTarget) return;

    e.preventDefault();

    const button = e.currentTarget;
    const snName = button.dataset.sn_name || 'эту сеть';


    const content = `Вы действительно хотите удалить ${snName} из списка связанных соц. сетей?`;
    const confirmButton = createElement('button', {class: ['button', 'button--s', 'button--black']}, 'Удалить');
    confirmButton.addEventListener('click', (event) => {
        closeModalWindow(event);
        deleteInAccountSmth(event);
    });
    const cancelButton = createElement('button', {type: 'button', class: ['button', 'button--s', 'button--black']}, 'Отменить');
    cancelButton.addEventListener('click', (event) => {
        closeModalWindow(event);
        removeElements('.g-message');
    });
    const modalFooter = createElement('div', {class: 'modal-window__2btns'});
    modalFooter.append(confirmButton);
    modalFooter.append(cancelButton);

    createSimpleModal(content, undefined, modalFooter);

    //button.disabled = true;
    window.actionType = 'sn-del';
}



// ----------------------------------------------------------------------------
// При удалении аккаунта

export function deleteAccountHelp(e) {
    e?.preventDefault();

    const content = `
            <p>Если вы хотите удалить свой аккаунт, впишите УДАЛИТЬ в поле ниже.<br>
            Обращаем внимание, что аккаунт будет удален в течении трех рабочих дней.</p>
            
            <p><input type="text" class="delete-input input input--m input--full" id="js-myaccount-del-input"></p>
        `;
    const confirmButton = createElement('button', {class: ['button', 'button--s', 'button--black']}, 'Удалить');
    confirmButton.addEventListener('click', (event) => {
        deleteInAccountSmth(event, document.getElementById('js-myaccount-del-input')?.value);
        closeModalWindow(event);
    });
    const cancelButton = createElement('button', {type: 'button', class: ['button', 'button--s', 'button--black']}, 'Отменить');
    cancelButton.addEventListener('click', (event) => {
        closeModalWindow(event);
        removeElements('.g-message');
    });
    const modalFooter = createElement('div', {class: 'modal-window__2btns'});
    modalFooter.append(confirmButton);
    modalFooter.append(cancelButton);

    createSimpleModal(content, undefined, modalFooter);

    window.actionType = 'account-del';
}



// ----------------------------------------------------------------------------
// При удалении вообще

export function deleteInAccountSmth(e) {
    e?.preventDefault();
    removeElements('.g-message');

    accountElements.accountHeader?.insertAdjacentHTML(
        'afterend',
        '<div class="g-message">Обработка данных...</div>'
    );

    if (window.actionType === 'avatar-del') {
        fetch ('/oauth/get_data.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({
                avatardel: 1
            })
        })
            .then(response => {
                if (!response.ok) throw new Error('Сетевая ошибка сервера');
                return response.json();
            })
            .then(data => {
                removeElements('.g-message');
                if (Number(data.RES) === 1) {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--ok">Аватар успешно удален</div>`
                    );
                    closeModalWindow();
                    ttLKScrollToMessage(1);
                    hideElement(document.getElementById('js-myaccount-avatar-del-btn'));
                    if (accountElements.avatar) accountElements.avatar.innerHTML = `
                    <img src="${window.staticURL}/img/y-static/no-profile-img.jpg" alt="no-profile-img">
                    `;
                    if (authElements.ttAuthAva) authElements.ttAuthAva.value = '';
                } else if (data.MSG) {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--error">${data.MSG}</div>`
                    );
                    ttLKScrollToMessage();
                } else {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--error">Удалить фото профиля не удалось. Попробуйте позже.</div>`
                    );
                    ttLKScrollToMessage();
                }
            })
            .catch(error => console.error('Произошла ошибка при отправке:', error))

    } else if (window.actionType === 'sn-del') {
        const btnCloseSocial = document.querySelector('.js-myaccount-social-close-btn');
        btnCloseSocial.disabled = true;
        const btnCloseSocialData = btnCloseSocial?.dataset.sn;

        if (btnCloseSocial && btnCloseSocialData) {
            fetch ('/oauth/get_data.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: new URLSearchParams({
                    sndel: btnCloseSocialData
                })
            })
                .then(response => {
                    if (!response.ok) throw new Error('Сетевая ошибка сервера');
                    return response.json();
                })
                .then(data => {
                    removeElements('.g-message');
                    btnCloseSocial.disabled = false;

                    if (Number(data.RES) === 1) {
                        hideElement(document.querySelector(`.js-myaccount-del-social-${btnCloseSocialData}`));
                        showElement(document.querySelector(`.js-myaccount-social-${btnCloseSocialData}`));

                        accountElements.accountHeader?.insertAdjacentHTML(
                            'afterend',
                            `<div class="g-message g-message--ok">${data.MSG}</div>`
                        );
                        ttLKScrollToMessage(1);
                    } else if (data.MSG) {
                        accountElements.accountHeader?.insertAdjacentHTML(
                            'afterend',
                            `<div class="g-message g-message--error">${data.MSG}</div>`
                        );
                        ttLKScrollToMessage();
                    } else {
                        accountElements.accountHeader?.insertAdjacentHTML(
                            'afterend',
                            `<div class="g-message g-message--error">Удалить ${btnCloseSocial.dataset.sn_name || 'эту сеть'} из списка связанных соц. сетей не удалось. Попробуйте позже.</div>`
                        );
                        ttLKScrollToMessage();
                    }
                })
                .catch(error => console.error('Произошла ошибка при отправке:', error))
        }
    } else if (window.actionType === 'account-del') {
        fetch ('/oauth/get_data.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({
                myaccountdel: document.getElementById('js-myaccount-del-input')?.value || ''
            })
        })
            .then(response => {
                if (!response.ok) throw new Error('Сетевая ошибка сервера');
                return response.json();
            })
            .then(data => {
                removeElements('.g-message');
                if (Number(data.RES) === 1) {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--ok">${data.MSG}</div>`
                    );
                    ttLKScrollToMessage(1);
                } else if (data.MSG) {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--error">${data.MSG}</div>`
                    );
                    ttLKScrollToMessage();
                } else {
                    accountElements.accountHeader?.insertAdjacentHTML(
                        'afterend',
                        `<div class="g-message g-message--error">Запрос на удаление данных выполнить не удалось. Попробуйте позже.</div>`
                    );
                    ttLKScrollToMessage();
                }
            })
            .catch(error => console.error('Произошла ошибка при отправке:', error))
    }

    hideElement(document.getElementById('js-modal-window'));
}

